import React, {useState, useEffect, forwardRef} from 'react';
import {Popover} from 'antd-mobile';

import './index.less';

function GstProgessBar({
  percent = 20, 
  color = '#C3924D', 
  backgroundColor = '#f2f2f2', 
  content='', 
  visiblePopover = 'true', 
  height = '6px', 
  radius = 10,
  onProgress = () => {  },
  ...props
}) {
  const onClickLeft = () => {
    // onProgress()
  }
  return (
    <div className="gst-progress-bar">
      <div className="gst-progress-bar-content" style={{
         height: height,
         backgroundColor: backgroundColor,
      }}>
        <Popover
          content={content}
          placement='bottom-end'
          mode='dark'
          trigger='click'
          visible={visiblePopover} 
        >
          <div className="gst-progress-bar-content-inner"
            onClick={() => onClickLeft()}
            style={{
            'width': `${percent}%`,
            'backgroundColor': color,
            borderRadius: radius,
          }}></div>
        </Popover>
      </div>
    </div>
  )
}

export default GstProgessBar;